import { getStoredLocale } from '@/i18n'

/** Locale headers for every API call so Laravel SetLocale can translate messages. */
export function getApiLocaleHeaders(): Record<string, string> {
  const locale = getStoredLocale()

  return {
    'Accept-Language': locale,
    'X-Locale': locale,
  }
}
